// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"57254dc9","1957":"b970b49f","3226":"b7be268f","4022":"064ebe15"}[chunkId] + ".chunk.css";
};